/*
 * @Author: Json Chen
 * @Date: 2021-07-15 09:37:03
 * @LastEditTime: 2022-02-11 16:43:44
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Components/NeedWarehouseLocation.tsx
 */
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import React from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  setVisiable?: any;
}

const NeedWarehouseLocation = ({ setVisiable }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const onModalConfirm = () => {
    history.push(`/settings/logistics/warehouselocation/setting`);
  };
  return (
    <React.Fragment>
      <div>
        {getI18n('storeLogistics.components.needWarehouseLocationTitle')}
      </div>
      <ModalFooter
        onCancel={() => {
          setVisiable(false);
        }}
        okText={getI18n('storeLogistics.components.createWarehouseLocation')}
        onOk={onModalConfirm}
      />
    </React.Fragment>
  );
};

export default NeedWarehouseLocation;
